// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"3ba1913b","599":"ca859775","835":"3ba1913b","881":"2e017e57"}[chunkId] + ".chunk.css";
};